const axios = require('axios');

export const makeAPICall = async (reqParams) => (await axios(reqParams)).data.Response.Results;
